import { Pipe, PipeTransform } from '@angular/core';
import { NumberFormatService } from 'src/app/core/services/number-format.service';
import { MemoizedNumberPipe } from './memoized-number-pipe.base';

/** Currency render through the user's number-format preset; same arg order as Angular's
 *  CurrencyPipe (minus the locale arg — separators are preset-driven, not locale-driven).
 *  Impure (re-renders on preset change, incl. cross-tab); memoized via the shared base so
 *  the per-cell instance only re-runs the symbol resolution + separator swap on change. */
@Pipe({ name: 'appCurrency', standalone: true, pure: false })
export class AppCurrencyPipe extends MemoizedNumberPipe implements PipeTransform {
  constructor(numberFormat: NumberFormatService) {
    super(numberFormat);
  }

  transform(
    value: number | null | undefined,
    currencyCode = '',
    display: string | boolean = 'symbol',
    digitsInfo?: string,
  ): string | null {
    return this.memoized(
      () => this.numberFormat.formatCurrency(value, currencyCode, display, digitsInfo),
      value, currencyCode, display, digitsInfo,
    );
  }
}
